import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import About from '@/pages/About';
import GSTServices from '@/pages/GSTServices';
import GSTRegistration from '@/pages/GSTRegistration';
import IncomeTaxServices from '@/pages/IncomeTaxServices';
import Billing from '@/pages/Billing';
import Contact from '@/pages/Contact';
import Pricing from '@/pages/Pricing';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gst-services" element={<GSTServices />} />
          <Route path="/gst-registration" element={<GSTRegistration />} />
          <Route path="/income-tax-services" element={<IncomeTaxServices />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
